import api from '../../../services/api';

class ServiceService {
  /**
   * Get all services
   */
  async getAllServices(page = 1, limit = 10, filters = {}) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...filters,
      });

      const response = await api.get(`/services?${params}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get popular services
   */
  async getPopularServices(limit = 8) {
    try {
      const response = await api.get(`/services/popular?limit=${limit}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Search services
   */
  async searchServices(query, page = 1, limit = 10) {
    try {
      const params = new URLSearchParams({
        q: query,
        page: page.toString(),
        limit: limit.toString(),
      });

      const response = await api.get(`/services/search?${params}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get services by category
   */
  async getServicesByCategory(category) {
    try {
      const response = await api.get(`/services/category/${category}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get service by ID
   */
  async getServiceById(serviceId, bypassCache = false) {
    try {
      // Add timestamp to bypass cache if needed
      const url = bypassCache 
        ? `/services/${serviceId}?_t=${Date.now()}`
        : `/services/${serviceId}`;
      const response = await api.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get service by slug
   */
  async getServiceBySlug(slug) {
    try {
      const response = await api.get(`/services/slug/${slug}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Create service (Admin only)
   */
  async createService(serviceData) {
    try {
      const response = await api.post('/services', serviceData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Update service (Admin only)
   */
  async updateService(serviceId, serviceData) {
    try {
      const response = await api.put(`/services/${serviceId}`, serviceData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Delete service (Admin only)
   */
  async deleteService(serviceId) {
    try {
      const response = await api.delete(`/services/${serviceId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get service statistics (Admin only)
   */
  async getServiceStats() {
    try {
      const response = await api.get('/services/stats');
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Initialize default services (Admin only)
   */
  async initializeDefaultServices() {
    try {
      const response = await api.post('/services/initialize');
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default new ServiceService();


